import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/GridLegacy';

const ResourceGroupListSkeleton = () => (
	<Grid container spacing={2} data-testid='skeletonLoading'>
		{[0, 1, 2, 3, 4, 5].map(index => (
			<Grid item xs={12} sm={6} md={4} key={`skeleton-${index}`}>
				<Skeleton variant='rectangle' height={300} />
			</Grid>
		))}
	</Grid>
);

export default ResourceGroupListSkeleton;
